var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sarai-action-page"},[_c('div',[_c('sarai-form',{attrs:{"gurudwara-id":_vm.computedGurudwaraId,"sarai-id":_vm.computedSaraiId,"is-edit-mode":_vm.computedIsEditMode},on:{"saved":_vm.handleSaved,"cancelled":_vm.handleBackClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }